export { SdgButtonComponent } from './sdg-button.component';
